import moment from "moment";
import { makeStyles } from "tss-react/mui";
import { MiChip, MiStackedTypography } from "@miplatform/components";
import { FONT_WEIGHTS, TIME_UNITS } from "@miplatform/constants";
import { getTimeDifference } from "@miplatform/utils";
import { Box } from "@mui/material";

export const HoldOrderListItems = ({
  holdStartDate,
  holdReason,
  holdCalendarName,
  orderTemplateName,
  orderTemplateShortName,
  orderTemplateColor,
}) => {
  const { classes } = useStyles({ orderTemplateColor });

  return (
    <Box display="flex" flexWrap="wrap" justifyContent="flex-end" gap={4}>
      <MiStackedTypography
        title="Hold days"
        description={`${
          getTimeDifference({
            start: moment(holdStartDate),
            end: moment.now(),
            timeUnit: TIME_UNITS.DAY,
          }) || "0"
        } days`}
        descriptionProps={{ width: 55, fontWeight: FONT_WEIGHTS.BOLD }}
      />
      <MiStackedTypography
        title="Hold Type"
        description={holdCalendarName || ""}
        descriptionProps={{ width: 55, fontWeight: FONT_WEIGHTS.BOLD }}
      />
      <MiStackedTypography
        title="Hold reason"
        description={holdReason || ""}
        descriptionProps={{ width: 100, fontWeight: FONT_WEIGHTS.BOLD }}
      />
      <MiStackedTypography
        title="Order"
        customTooltip={orderTemplateName}
        descriptionProps={{
          minWidth: 100,
          maxWidth: 100,
          fontWeight: FONT_WEIGHTS.BOLD,
          children: (
            <>
              <MiChip
                className={classes.orderChip}
                label={orderTemplateShortName}
                size="small"
              />
              {orderTemplateName}
            </>
          ),
        }}
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme, { orderTemplateColor }) => ({
  orderChip: {
    borderRadius: theme.spacing(2),
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: orderTemplateColor,
  },
}));
